import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router'
import { makeStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import { roomDoc } from '../../utils/firebase'
import { onSnapshot } from 'firebase/firestore'
import { RoomType } from '../../utils/types'
import Room from './Room'
import Spinner from '../Spinner'
import Layout from '../Layout'

const useStyles = makeStyles(theme => ({
  paper: {
    height: '100%',
    minHeight: 200,
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(4),
  },
  container: {
    height: '100%',
  },
}))

const RoomLoader: React.FC = () => {
  const classes = useStyles()
  const { roomId } = useParams<{ roomId: string }>()

  const [loading, setLoading] = useState(true)
  const [room, setRoom] = useState<RoomType | undefined>()

  useEffect(() => {
    onSnapshot(roomDoc(roomId), doc => {
      const roomData = doc.data() as RoomType
      setRoom(roomData)
      setLoading(false)
    })
  }, [roomId])

  return (
    <Layout>
      <Paper className={classes.paper}>
        <Grid container className={classes.container}>
          <Grid item xs={12}>
            <Spinner loading={loading} />

            {!loading && !room && <Typography>Room not found</Typography>}
            {!loading && room && <Room room={room} />}
          </Grid>
        </Grid>
      </Paper>
    </Layout>
  )
}

export default RoomLoader
